import moment from "moment";

const methods = {
  normalDate(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("MM/DD/YYYY");
      return local;
    }
    return "";
  },
  longDate(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("MMMM DD, YYYY");
      return local;
    }
    return "";
  },
  longDateNoTz(date) {
    if (date) {
      var local = moment(date).format("MMMM DD, YYYY");
      return local;
    }
    return "";
  },
  time(date) {
    if (date) {
      var local = moment
        .utc(date)
        .local()
        .format("hh:mm A");
      return local;
    }
    return "";
  }
};

export default methods;
